import { baseFetch } from '../../baseFetch';
import {
  AddPartnerFarmRequest,
  PartnerFarmLinksResponseSchema,
  PartnerFarmResponseSchema,
  UpdatePartnerFarmKeyRequest,
  UpdatePartnerFarmStatusRequest,
} from './solar-farm-partners.schema';

export const getFarmPartners = (solarFarmId: number) =>
  baseFetch(
    'internal-v2',
    `/solar_farms/${solarFarmId}/partners`,
    PartnerFarmLinksResponseSchema,
  );

export const addPartnerFarm = (
  solarFarmId: number,
  partnerId: number,
  body: AddPartnerFarmRequest,
) =>
  baseFetch(
    'internal-v2',
    `/solar_farms/${solarFarmId}/partners/${partnerId}`,
    PartnerFarmResponseSchema,
    { method: 'POST', requestBody: body },
  );

export const updatePartnerFarmKey = (
  solarFarmId: number,
  partnerId: number,
  body: UpdatePartnerFarmKeyRequest,
) =>
  baseFetch(
    'internal-v2',
    `/solar_farms/${solarFarmId}/partners/${partnerId}/key`,
    PartnerFarmResponseSchema,
    { method: 'PATCH', requestBody: body },
  );

export const updatePartnerFarmStatus = (
  solarFarmId: number,
  partnerId: number,
  body: UpdatePartnerFarmStatusRequest,
) =>
  baseFetch(
    'internal-v2',
    `/solar_farms/${solarFarmId}/partners/${partnerId}/status`,
    PartnerFarmResponseSchema,
    { method: 'PATCH', requestBody: body },
  );
